import type { CreateUIAnalyticsEvent } from '@atlaskit/analytics-next/types';

import { START_TOUCH } from '@confluence/navdex/entry-points/NavdexPointType.ts';

export const fireLogoClickedAnalytics =
	(createAnalyticsEvent: CreateUIAnalyticsEvent, routeName: any) => (): void => {
		createAnalyticsEvent({
			type: 'sendUIEvent',
			data: {
				source: 'globalNavigation',
				action: 'clicked',
				actionSubject: 'navigationItem',
				actionSubjectId: 'productLogo',
				attributes: {
					selectedItemPageContext: routeName,
					navigationLayer: 'global',
					navigationContainer: 'top',
					navVersion: '4',
					navdexPointType: START_TOUCH,
				},
			},
		}).fire();
	};

export const fireNotificationsClickedAnalytics =
	(createAnalyticsEvent: CreateUIAnalyticsEvent, routeName: any) => (): void => {
		createAnalyticsEvent({
			type: 'sendUIEvent',
			data: {
				source: 'globalNavigation',
				action: 'clicked',
				actionSubject: 'navigationItem',
				actionSubjectId: 'notifications',
				attributes: {
					selectedItemPageContext: routeName,
					navigationLayer: 'global',
					navigationContainer: 'top',
					navVersion: '4',
					navdexPointType: START_TOUCH,
				},
			},
		}).fire();
	};

export const fireProfileClickedAnalytics =
	(createAnalyticsEvent: CreateUIAnalyticsEvent, routeName: any, isExternalCollaborator: any) =>
	(): void => {
		createAnalyticsEvent({
			type: 'sendUIEvent',
			data: {
				source: 'globalNavigation',
				action: 'clicked',
				actionSubject: 'navigationItem',
				actionSubjectId: 'profile',
				attributes: {
					selectedItemPageContext: routeName,
					navigationLayer: 'global',
					navigationContainer: 'top',
					navVersion: '4',
					navdexPointType: START_TOUCH,
					is_guest: isExternalCollaborator,
				},
			},
		}).fire();
	};
